exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media print {\n  html, body {\n    overflow: visible !important; }\n  body {\n    margin: 0;\n    padding: 0;\n    line-height: 1.4em;\n    word-spacing: 1px;\n    letter-spacing: 0.2px;\n    font: 13px Arial, Helvetica,\"Lucida Grande\", serif;\n    color: #000; }\n  h2 {\n    color: #000;\n    font-size: 25px; }\n  a:link, a:visited {\n    background: transparent;\n    color: #333;\n    text-decoration: none; }\n  a[href^=\"http://\"] {\n    color: #000; }\n  .page-heading, .ibox-footer, a, button, .btn {\n    display: none !important; }\n  img, img a, .more-link a {\n    border: none; }\n  .ibox-content {\n    border: 0px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./~/sass-loader!./src/assets/css/print.scss
// module id = 852
// module chunks = 2